import PropTypes from "prop-types";
import Grid from "@mui/material/Unstable_Grid2";
import { Typography, Link } from "@mui/material";
import dayjs from "dayjs";
import { MAPPING_KEYS_DATE_FORMAT } from "../../../constants";

import { initLocalization } from "../../../utils/helpers";
import { poolMetadataStrings } from "./locale";
import "./style.scss";

export const PoolMetadata = ({ creativeDetails, isReview = false }) => {
  initLocalization(poolMetadataStrings);

  return (
    <Grid>
      <Typography paddingLeft="0.5rem" fontWeight="bold">
        {poolMetadataStrings.metadataTitle}:
      </Typography>
      <Grid className="pool-metadata" container flexDirection="column">
        <Grid container width="100%" className="pool-metadata__table-row">
          <Typography className="pool-metadata__table-title">
            {poolMetadataStrings.date}
          </Typography>
          <Typography className="pool-metadata__table-content">
            {dayjs(creativeDetails.date).format(MAPPING_KEYS_DATE_FORMAT)}
          </Typography>
        </Grid>
        <Grid container width="100%" className="pool-metadata__table-row">
          <Typography className="pool-metadata__table-title">
            {poolMetadataStrings.id}
          </Typography>
          <Typography className="pool-metadata__table-content">
            {creativeDetails.id}
          </Typography>
        </Grid>
        {!isReview && (
          <>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.sponsoredType}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.sponsoredType}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.advertiserName}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.advertiserName}
              </Typography>
            </Grid>
            <Grid container width="100%" className="pool-metadata__table-row">
              <Typography className="pool-metadata__table-title">
                {poolMetadataStrings.advertiserPaid}
              </Typography>
              <Typography className="pool-metadata__table-content">
                {creativeDetails.advertiserPaid}
              </Typography>
            </Grid>
          </>
        )}
        <Grid container width="100%" className="pool-metadata__table-row">
          <Typography className="pool-metadata__table-title">
            {poolMetadataStrings.link}
          </Typography>
          <Typography
            className="pool-metadata__table-content"
            sx={{ wordBreak: "break-all" }}
          >
            <Link href={creativeDetails.creativeLink} target="_blank">
              {creativeDetails.creativeLink}
            </Link>
          </Typography>
        </Grid>
        <Grid container width="100%" className="pool-metadata__table-row">
          <Typography className="pool-metadata__table-title">
            {poolMetadataStrings.title}
          </Typography>
          <Typography className="pool-metadata__table-content">
            {creativeDetails.title}
          </Typography>
        </Grid>
      </Grid>
    </Grid>
  );
};

PoolMetadata.propTypes = {
  creativeDetails: PropTypes.object.isRequired,
  isReview: PropTypes.bool,
};
